
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.297 13.06a1.5 1.5 0 000-2.12L2.75 1.392A1.5 1.5 0 10.629 3.515L9.115 12 .629 20.485a1.5 1.5 0 102.122 2.122l9.546-9.546zM9 13.5h2.236v-3H9v3z","fill":"#A3A3A3"}})])
          )
        }
      }
    